import React from 'react';

const NotFound = () => {
  return (
    <p>404</p>
  );
}

export default NotFound;
